import { createAction } from 'redux-actions';

export const setCurrentPage = createAction('SET_CURRENT_PAGE');
export const resetPagination = createAction('RESET_PAGINATION');
export const setCurrentTable = createAction('SET_CURRENT_TABLE');
